/** use all component */
// import iview from 'iview';
/** use some */
//basic
import { Row, Col } from 'iview/src/components/grid';
import button from 'iview/src/components/button';
import buttonGroup from 'iview/src/components/button/button-group';
import icon from 'iview/src/components/icon';
//form
import input from 'iview/src/components/input';
// import input from '@/components/iview/input.vue';
import inputNumber from '@/packages/iview/components/input-number';
// import inputNumber from 'iview/src/components/input-number';
import radio from 'iview/src/components/radio';
import radioGroup from 'iview/src/components/radio/radio-group.vue';
import checkbox from 'iview/src/components/checkbox';
// import checkbox from '@/packages/iview/components/checkbox';
import checkboxGroup from 'iview/src/components/checkbox/checkbox-group';

// import { Option, OptionGroup } from 'iview/src/components/select'; // Select
// import Select from 'iview/src/components/select'

// import { Option, OptionGroup } from '@/packages/iview/components/select/index'; //Select
// import Select from '@/packages/iview/components/select/select'

// //iview@3.x
import { Option, OptionGroup } from 'iview/src/components/select'; // Select
import Select from '@/packages/iview@3.x/components/select'

import slider from 'iview/src/components/slider';
// datePicker
import datePicker from 'iview/src/components/date-picker';
// import datePicker from '@/packages/iview/components/date-picker/';
import timePicker from 'iview/src/components/time-picker';

import form from 'iview/src/components/form/form.vue';
import formItem from 'iview/src/components/form/form-item.vue';
// import form from '@/packages/iview/components/form.vue';
// import formItem from '@/packages/iview/components/form-item.vue';
//switch
import iv_switch from 'iview/src/components/switch';
//view
import card from 'iview/src/components/card';
import message from 'iview/src/components/message';
import notice from 'iview/src/components/notice';
// import modal from 'iview/src/components/modal';
// import modalComponent from 'iview/src/components/modal/modal.vue';
import modal from '@/packages/iview@3.x/components/modal/index.js';
import modalComponent from '@/packages/iview@3.x/components/modal/modal.vue';
import progress from 'iview/src/components/progress';
import badge from 'iview/src/components/badge';
import tag from 'iview/src/components/tag';
import tooltip from 'iview/src/components/tooltip';
import poptip from 'iview/src/components/poptip';
import tree from 'iview/src/components/tree';
import alert from 'iview/src/components/alert';
import treeNode from 'iview/src/components/tree/node';
import table from 'iview/src/components/table';
// import table from '@/packages/iview/components/table/table.vue'
//navigation
import menu from 'iview/src/components/menu';
import menuGroup from 'iview/src/components/menu/menu-group';
import menuItem from 'iview/src/components/menu/menu-item';
import submenu from 'iview/src/components/menu/submenu';

import tabs from 'iview/src/components/tabs';
import tabPane from 'iview/src/components/tabs/pane';
import dropdown from 'iview/src/components/dropdown';
import dropdownMenu from 'iview/src/components/dropdown/dropdown-menu';
import dropdownItem from 'iview/src/components/dropdown/dropdown-item';
import page from 'iview/src/components/page';
import breadcrumb from 'iview/src/components/breadcrumb';
import breadcrumbItem from 'iview/src/components/breadcrumb/breadcrumb-item.vue';
import loadingBar from 'iview/src/components/loading-bar';
//chart
import circle from 'iview/src/components/circle';
//other
import spin from 'iview/src/components/spin';
import steps from 'iview/src/components/steps/steps';
import step from 'iview/src/components/steps/step';
import avatar from 'iview/src/components/avatar/';

import upload from 'iview/src/components/upload/upload';

import autoComplete from '@/packages/iview@3.x/components/auto-complete';
import Timeline from 'iview/src/components/timeline/';

export class iView{
    constructor(){
        this.prefix = 'iv';
    }
    install(Vue){
        button.name = this.prefix + 'Button';
        input.name = this.prefix + 'Input';
        table.name = this.prefix + 'Table';
        // menu.name = this.prefix + 'Menu';
        // menuItem.name = this.prefix + 'MenuItem';
        circle.name = this.prefix + 'Circle';
        //basic
        Vue.component(this.prefix+'Row', Row);
        Vue.component(this.prefix+'Col', Col);
        Vue.component(this.prefix+'Button', button);
        Vue.component(this.prefix+'ButtonGroup', buttonGroup);
        Vue.component(this.prefix+'Icon', icon);
        //form
        Vue.component(this.prefix + 'Input', input);
        Vue.component(this.prefix + 'InputNumber', inputNumber);
        Vue.component(this.prefix+'Radio', radio);
        Vue.component(this.prefix+'RadioGroup', radioGroup);
        Vue.component(this.prefix+'Checkbox', checkbox);
        Vue.component(this.prefix+'CheckboxGroup', checkboxGroup);
        Vue.component(this.prefix+'Select', Select);
        Vue.component(this.prefix+'Option', Option);
        Vue.component(this.prefix+'OptionGroup', OptionGroup);
        Vue.component(this.prefix+'Slider', slider);
        Vue.component(this.prefix+'DatePicker', datePicker);
        Vue.component(this.prefix+'TimePicker', timePicker);
        Vue.component(this.prefix+'Form', form);
        Vue.component(this.prefix+'FormItem', formItem);
        Vue.component(this.prefix+'Switch', iv_switch);
        //view
        Vue.component(this.prefix+'Card', card);
        Vue.component(this.prefix+'Modal', modalComponent);
        Vue.component(this.prefix+'Progress', progress);
        Vue.component(this.prefix+'Badge', badge);
        Vue.component(this.prefix+'Tag', tag);
        Vue.component(this.prefix+'Tooltip', tooltip);
        Vue.component(this.prefix+'Poptip', poptip);
        Vue.component(this.prefix + 'Tree', tree);
        Vue.component(this.prefix + 'TreeNode', treeNode);
        Vue.component(this.prefix + 'Alert', alert);
        Vue.component(this.prefix + 'Table', table);
        //navigation
        Vue.component(this.prefix+'Menu', menu);
        Vue.component(this.prefix+'MenuGroup', menuGroup);
        Vue.component(this.prefix+'MenuItem', menuItem);
        Vue.component(this.prefix+'Submenu', submenu);

        Vue.component(this.prefix+'Tabs', tabs);
        Vue.component(this.prefix+'TabPane', tabPane);
        Vue.component(this.prefix+'Dropdown', dropdown);
        Vue.component(this.prefix+'DropdownMenu', dropdownMenu);
        Vue.component(this.prefix+'DropdownItem', dropdownItem);
        Vue.component(this.prefix+'Page', page);
        Vue.component(this.prefix + 'Breadcrumb', breadcrumb);
        Vue.component(this.prefix + 'BreadcrumbItem', breadcrumbItem);
        //chart
        Vue.component(this.prefix+'Circle', circle);
        //other
        Vue.component(this.prefix+'Spin', spin);
        Vue.component(this.prefix+'Steps', steps);
        Vue.component(this.prefix+'Step', step);

        Vue.component(this.prefix + 'Avatar', avatar);

        Vue.component(this.prefix + 'Upload', upload);
        Vue.component(this.prefix + 'Upload', upload);

        Vue.component(this.prefix + 'AutoComplete', autoComplete);
        Vue.component(this.prefix + 'Timeline', Timeline);
        Vue.component(this.prefix + 'TimelineItem', Timeline.Item);

        Vue.prototype['$'+this.prefix+'Loading'] = loadingBar;
        Vue.prototype['$'+this.prefix+'Modal'] = modal;
        Vue.prototype['$'+this.prefix+'Notice'] = notice;
        Vue.prototype['$'+this.prefix+'Message'] = message;
    }
}

export default new iView();
